import {
  BookHalf,
  CheckCircle,
  ClipboardCheck,
  ClockHistory,
  CloudDownload,
  CloudSlash,
  LightningFill,
  PatchCheck,
  PlayCircle,
  QuestionOctagon,
  ShieldShaded,
  Signpost2
} from 'react-bootstrap-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const relayFlags = {
  "Authority": {
    "icon": <PatchCheck />,
    "tooltip": "This relay is a directory authority."
  },
  "BadExit" : {
    "icon": <CloudSlash />,
    "tooltip": "This relay is believed to be useless as an exit node (because its ISP censors it, because it is behind a restrictive proxy, or for some similar reason)."
  },
  "Exit" : {
    "icon": <CloudDownload />,
    "tooltip": "This relay is more useful for building general-purpose exit circuits than for relay circuits."
  },
  "Fast": {
    "icon": <LightningFill />,
    "tooltip": "This relay is suitable for high-bandwidth circuits."
  },
  "Guard": {
    "icon": <ShieldShaded />,
    "tooltip": "This relay is suitable for use as an entry guard."
  },
  "HSDir": {
    "icon": <Signpost2 />,
    "tooltip": "This relay is considered a v2 hidden service directory.",
  },
  "NoEdConsensus": {
    "icon": <QuestionOctagon />,
    "tooltip": "An Ed25519 key in the relay's descriptor or microdesriptor does not reflect authority consensus."
  },
  "Running": {
    "icon": <PlayCircle />,
    "tooltip": "This relay is currently usable."
  },
  "Stable": {
    "icon": <CheckCircle />,
    "tooltip": "This relay is suitable for long-lived circuits."
  },
  "StaleDesc": {
    "icon": <ClockHistory />,
    "tooltip": "This relay should upload a new descriptor because the old one is too old."
  },
  "V2Dir": {
    "icon": <BookHalf />,
    "tooltip": "This relay implements version 2 of the directory protocol (or later)."
  },
  "Valid": {
    "icon": <ClipboardCheck />,
    "tooltip": "This relay has been \"validated\"."
  }
}

function RelayFlag(props) {
  if (!(props.flag in relayFlags)) {
    console.log("Unknown flag " + props.flag);
    return "";
  }
  const icon = relayFlags[props.flag].icon;
  const tooltip = relayFlags[props.flag].tooltip;
  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
          {(props.text ? "" : props.flag + ": ") + tooltip}
        </Tooltip>
      }
    >
      <span>
        {icon}
        {props.text ? props.flag + " " : ""}
      </span>
    </OverlayTrigger>
  );
}

export default RelayFlag;
